// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#2e383f","menuText":"#bfcbd9","menuActiveText":"#409eff","theme":"#1890ff"};